import React from 'react'
import { AppBar, Toolbar, Box, Button,Typography } from '@mui/material'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import InstagramIcon from '@mui/icons-material/Instagram';

import { useNavigate } from 'react-router-dom'

export default function TopBar() {
   const navigate = useNavigate()
  return (
    <>
        <AppBar position="static" color="inherit" sx={{ maxWidth: '100%', overflow: 'hidden', backgroundColor: 'grey.100'}} elevation={0}>
            <Toolbar sx={{ px: 2, mt: 1.5}}>
                {/* logo */}
                <Box
                component="img"
                src="/logo.png"           /* <-- swap for your Shop logo path */
                alt="shop"
                sx={{ height: 64, width: 64, mr: 2 }}
                onClick={() => navigate('/')}
                />
                          {/* Title */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, alignItems: 'center', mt: 1.5 }}>
                        <Typography
                            variant="h6"
                            sx={{
                            mr: 3,
                            fontSize: '1.3rem',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'black',
                            }}
                        >
                            HOLY WEAR HOUSE
                        </Typography>
                        {/* Subtitle */}
                        <Typography
                            variant="caption"
                            sx={{
                                mr: 3,
                                mt: 1,
                                textAlign: 'center',
                                color: 'black',
                                // fontFamily: "cursive", 
                                fontSize: '0.7rem', 
                                fontWeight: 'bold',
                                position: 'relative', 
                                top: '-12px', // Pulls it up; adjust as needed                       
                                // transform: 'rotate(-5deg)', // Rotates counter-clockwise; adjust angle
                                whiteSpace: 'nowrap', // Prevents text from wrapping due to rotation
                            }}
                        >
                            One stop shop for believers.
                        </Typography>
                        </Box>

                {/* Instagram / Giveaway button */}
                <Button
                    sx={{
                        width: 48,
                        height: 48,
                        minWidth: 0,
                        minHeight: 0,
                        position: 'relative',
                    }}
                    onClick={() => {
                        window.open('https://www.instagram.com/holywearhouse/', '_blank');
                    }}
                >
                    <InstagramIcon sx={{ fontSize: 32, mr: 1, color: 'black' }} />
                </Button>
            </Toolbar>
        </AppBar>
    
        {/* search input */}
        {/* <TextField
          variant="outlined"
          size="small"
          fullWidth
          placeholder="What are you looking for?"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment sx={{ marginLeft: '8px'}} position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            mx: 3,
            mb: 1,
            mt: 2,
            width: '90%',
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
              backgroundColor: 'black.100',
              height: 36,
              padding: 0,
            },
            '& .MuiOutlinedInput-input': {
            padding: '6px 8px', // Adjusts the inner padding for smaller height
            },
          }}
        /> */}
    </>

  )
}
